// extracted by mini-css-extract-plugin
export default {"root":"EmbeddedApp_root__UvrW+"};